import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/PuiPi-Market/client/src/views/HomePage.js");
